import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import Utils from "../../../utils/Utils";
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';
import { de } from "date-fns/locale";

class SendPasswordReminderTaks extends AbstractRequestTask {
  constructor(body = {}) {
    super();
    this.body = body;
    this.statusCode422As200 = true;
  }

  getParams() {
    return Utils.encodeParams(this.body);
  }

  getMethod() {
    return 'POST';
  }

  getHeaders() {
    return {
      'Content-Type': 'application/x-www-form-urlencoded'
    };
  }

  getUrl() {
    const url = Launcher.get("akamai_mfwk");
    return `${url}/services/user/sendtemporalcode?${this.getQueryStringParams()}`;
  }

  getQueryStringParams() {
    let params = super.getParams();
    delete params.user_token;
    params = Object.assign({}, params);
    return Utils.buildQueryParams(params);
  }

  getShowErrorModal(){
    return ENABLE_MODAL_RETRIES;
  }
}

export default SendPasswordReminderTaks;



// WEBPACK FOOTER //
// ./src/requests/tasks/user/SendPasswordReminderTaks.js